import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

export const SignatureItems = ({
  items,
  isDarkMode,
  handleSignatureClick,
}: any) => {
  const sortedItems = [...items].sort((a, b) => {
    const dateA = new Date(a.details.signedAt).getTime();
    const dateB = new Date(b.details.signedAt).getTime();
    return dateA - dateB;
  });

  return (
    <div className="px-3 pb-3 mt-3 space-y-2">
      {sortedItems.map((action, index) => {
        const signatureData = action.details;
        const signerName = signatureData.patientRelationStatus.name;
        const relationship =
          signatureData.patientRelationStatus.relationship || "";
        const consentText =
          signatureData.consentStatement || signatureData.purpose || "";
        const signatureImage =
          signatureData.signatureData || signatureData.signature;

        return (
          <div
            key={action.id}
            className={`flex items-start gap-2 p-2 rounded cursor-pointer ${
              isDarkMode ? "bg-gray-800/50" : "bg-white/80"
            }`}
            onClick={() => handleSignatureClick(signatureData)}
          >
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-mono text-xs text-gray-600">
                  #{index + 1}
                </span>
                <span
                  className={`text-sm font-semibold ${
                    isDarkMode ? "text-gray-200" : "text-gray-900"
                  }`}
                >
                  {signerName}
                </span>
                {relationship && (
                  <span
                    className={`text-xs ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    ({relationship})
                  </span>
                )}
              </div>
              {consentText && (
                <p
                  className={`text-xs ml-6 italic ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  "{consentText}"
                </p>
              )}
              {signatureImage && (
                <div className="mt-2 ml-6">
                  <img
                    src={signatureImage}
                    alt="Signature"
                    className={`h-12 border rounded ${
                      isDarkMode
                        ? "border-gray-700 bg-white"
                        : "border-gray-300 bg-white"
                    }`}
                  />
                </div>
              )}
            </div>
            <div
              className="flex items-center gap-1"
              onClick={(e) => e.stopPropagation()}
            >
              <div onClick={(e) => e.stopPropagation()}>
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    {/* <button
                      className={`p-1 rounded transition-colors ${
                        isDarkMode
                          ? "hover:bg-red-900/20 text-red-400 hover:text-red-300"
                          : "hover:bg-red-50 text-red-600 hover:text-red-700"
                      }`}
                      title="Delete signature"
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button> */}
                  </AlertDialogTrigger>
                  <AlertDialogContent>
                    <AlertDialogHeader>
                      <AlertDialogTitle>Delete Signature</AlertDialogTitle>
                      <AlertDialogDescription>
                        Are you sure you want to delete this signature? This
                        cannot be undone.
                      </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                      <AlertDialogCancel>Cancel</AlertDialogCancel>
                      <AlertDialogAction
                        // onClick={() => onDelete(action.id)}
                        className="bg-red-600 hover:bg-red-700"
                      >
                        Delete
                      </AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
